import { useQuery } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";

const useGetActiveUsers = () => {
  const data = useQuery(["activeUsersList"], () =>
    axiosClient.get("/User/GetActiveUsers")
  );

  return data;
};
export default useGetActiveUsers;
